import { ClipboardList, Link2, Bot, BookOpen, Megaphone, Handshake } from "lucide-react";

// Strumenti aggiuntivi attivabili dall'Admin per ciascun Partner (le 4 funzioni principali sono sempre visibili).
export const PARTNER_TOOLS = [
  { key: "nuova_richiesta", label: "Nuova richiesta", desc: "Registra una richiesta da quotare.", icon: ClipboardList, to: "/richieste/nuova" },
  { key: "link_cliente", label: "Link cliente", desc: "Invia un modulo da compilare al cliente.", icon: Link2, to: "/link-cliente", agencyOnly: true },
  { key: "assistente", label: "Assistente AI", desc: "Domande tecniche sui prodotti.", icon: Bot, to: "/assistente" },
  { key: "marketing", label: "Landing & Hub prodotti", desc: "Materiali da condividere.", icon: Megaphone, to: "/hub-prodotti" },
  { key: "guida", label: "Manuali & Guida", desc: "Novità e istruzioni.", icon: BookOpen, to: "/guida" },
];
export const ALL_TOOL_KEYS = PARTNER_TOOLS.map((t) => t.key);

const AGENCY_ROLES = ["agency_admin", "agency_operator", "agency_catnat"];

// Chiavi strumenti attive: completo/assente → tutti; minimo → nessuno; personalizzato → elenco salvato.
export function enabledToolKeys(user) {
  if (!user) return [];
  if (AGENCY_ROLES.includes(user.role)) return ALL_TOOL_KEYS;
  const p = user.partner || {};
  if (p.dashboard_profile === "minimo") return [];
  if (p.dashboard_profile === "personalizzato") return Array.isArray(p.dashboard_tools) ? p.dashboard_tools : [];
  return ALL_TOOL_KEYS;
}

export function visibleTools(user) {
  const keys = enabledToolKeys(user);
  const agencyDirect = user?.role === "partner_collab_AA" || AGENCY_ROLES.includes(user?.role);
  const tools = PARTNER_TOOLS.filter((t) => keys.includes(t.key) && (!t.agencyOnly || agencyDirect));
  return user?.rete_solidale_access ? [...tools, RETE_TOOL] : tools;
}

// Card "Rete Solidale": poteri Agenzia su Accordi, Convenzioni e Vetrina, concessi dall'Admin al singolo Partner.
export const RETE_TOOL = { key: "rete_solidale", label: "Rete Solidale", desc: "Accordi, convenzioni e vetrina, con i poteri dell'Agenzia.", icon: Handshake, to: "/rete-gestione" };
